import { motion } from "framer-motion";
import '../css/style.css';

function Kontakt() {

  return (
    <motion.div
      key="kontakt"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="kontakt-container"
    >
      <div className="top-contact kontakt-loader">
        <div className="contact-title">Rychlý kontakt</div>
        <div className="contact-phone">
          <div className="contact-label"></div>
          <div className="contact-item">
            <span className="contact-value tel"></span>
          </div>
        </div>
        <div className="contact-email">
          <div className="contact-label"></div>
          <div className="contact-item">
            <span className="contact-value email" dangerouslySetInnerHTML={{__html: ''}}></span>
          </div>
        </div>
      </div>
      
      <div className="contact-content">
        <div className="contact-card e-shop-card kontakt-loader">
          <h2 className="card-title" dangerouslySetInnerHTML={{__html: ''}}></h2>
          <div className="card-content">
            <div className="address-block">
              <p className="info-content"></p>
              <p className="info-content"></p>
              <p className="info-content" style={{marginLeft: "30px"}}></p>
            </div>
            
            <div className="contact-regions">
              <div className="contact-region">
                <h3 className="info-title" dangerouslySetInnerHTML={{__html: ''}}></h3>
                  <p className="info-content"></p>
                <p className="info-content"></p>
                <p className="info-content"><span className="email" dangerouslySetInnerHTML={{__html: ''}}></span></p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="contact-row">
          <div className="contact-card reklamace-card kontakt-loader">
            <h2 className="card-title" dangerouslySetInnerHTML={{__html: ''}}></h2>
            <div className="card-content">
              <p className="info-content"></p>
              <p className="info-content"></p>
              <p className="info-content" style={{marginLeft: "5px"}}></p>
              
              <p className="info-content info-spacing"></p>
              <p className="info-content"><span className="email" dangerouslySetInnerHTML={{__html: ''}}></span></p>
              
              <p className="info-content info-note"></p>
            </div>
          </div>
          
          <div className="contact-card international-card kontakt-loader">
            <h2 className="card-title" dangerouslySetInnerHTML={{__html: ''}}></h2>
            <div className="card-content">
              <div className="international-content international-content-data" style={{display: "block", position: "relative", top: "50px"}}>
                <p className="info-content inernational-content-email"></p>
                <p className="info-content inernational-content-email"></p>
                <p className="info-content inernational-content-email"></p>
                <p className="info-content inernational-content-email"><span className="email" dangerouslySetInnerHTML={{__html: ''}}></span></p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="contact-card fakturacni-card kontakt-loader">
          <h2 className="card-title" dangerouslySetInnerHTML={{__html: ''}}></h2>
          <div className="card-content">
            <div className="fakturacni-columns">
              <div className="fakturacni-column">
                <p className="info-content"></p>
                <p className="info-content"></p>
                <p className="info-content" style={{marginLeft: "30px"}}></p>
              </div>
              
              <div className="fakturacni-column">
                <p className="info-content">IČO:</p>
                <p className="info-content">DIČ:</p>
                <p className="info-content">OR:</p>
                <p className="info-content">Spisová značka</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Kontakt;